import { useState } from "react";
import { LittleSpace, UsernameContainer, UsernameWrapper } from "./style";
import { InputDiv } from "../../../reuseableComp.tsx/InputWithLogo";
import { Button } from "../../../reuseableComp.tsx/Button";
import axios from "axios";
import { Error } from "../../Signup/style";
import { Dna } from "react-loader-spinner";

interface Close {
  closeFunc: () => void;
}

const AddNamesModal = ({ closeFunc }: Close) => {
  const [isContinue, setISContinue] = useState(false);
  const [firstName, setfirstName] = useState("");
  const [lastName, setlastName] = useState("");
  const storedToken = sessionStorage.getItem("token");
  const token = `Bearer ${storedToken}`;
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const Authorization = {
    Authorization: token,
    "Content-Type": "application/json",
  };

  const handleContinue = () => {
    setISContinue(true);
  };

  const payload = {
    firstName: firstName,
    lastName: lastName,
  };

  const handleAddName = () => {
    setLoading(true);
    axios
      .put(`${process.env.REACT_APP_API_BASE_ENDPOINT}/name`, payload, {
        headers: Authorization,
      })
      .then((res: any) => {
        setSuccess(res.data.message);
        setLoading(false);
        setTimeout(() => {
          closeFunc();
        }, 4000);
      })
      .catch((err) => {
        setError(err.response.data.message);
        setLoading(false);
        setTimeout(() => {
          setError("");
        }, 3000);
      });
  };

  return (
    <UsernameContainer>
      <UsernameWrapper>
        {isContinue ? (
          <h2>Enter Your Last name</h2>
        ) : (
          <h2>Enter Your First name</h2>
        )}
        {isContinue ? (
          <p>To proceed, enter your last name.</p>
        ) : (
          <p>Please Enter your Your Firstname</p>
        )}
        <InputDiv>
          <div>icon</div>
          <div>
            <input
              type="text"
              placeholder="Firstname"
              value={firstName}
              onChange={(e) => setfirstName(e.target.value)}
              required
            />
          </div>
        </InputDiv>
        <br />
        {isContinue && (
          <InputDiv>
            <div>icon</div>
            <div>
              <input
                type="text"
                placeholder="Lastname"
                value={lastName}
                onChange={(e) => setlastName(e.target.value)}
                required
              />
            </div>
          </InputDiv>
        )}
        <br />

        <>
          {success && (
            <>
              <LittleSpace>
                <Error>
                  <span>{success}</span>
                </Error>
              </LittleSpace>
            </>
          )}

          {error && (
            <>
              <LittleSpace>
                <Error>
                  <p>{error}</p>
                </Error>
              </LittleSpace>
            </>
          )}
        </>
        {isContinue ? (
          <>
            <Button disabled={!lastName} onClick={handleAddName}>
              {loading ? (
                <>
                  <Dna
                    visible={true}
                    height="50"
                    width="80"
                    ariaLabel="dna-loading"
                    wrapperStyle={{}}
                    wrapperClass="dna-wrapper"
                  />
                </>
              ) : (
                <>Set Name</>
              )}
            </Button>
          </>
        ) : (
          <>
            <Button disabled={!firstName} onClick={handleContinue}>
              Continue
            </Button>
          </>
        )}
      </UsernameWrapper>
    </UsernameContainer>
  );
};
export default AddNamesModal;
